import { Link } from 'react-router-dom'
import { nav } from '../nav'
import { ArrowRight, BookOpen } from 'lucide-react'

export function Home() {
  return (
    <div className="px-8 py-12 max-w-4xl mx-auto">
      {/* Hero */}
      <div className="mb-12">
        <div className="flex items-center gap-3 mb-5">
          <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center shadow-md">
            <BookOpen size={22} className="text-white" />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-slate-900 leading-none">Crawl</h1>
            <p className="text-slate-400 text-sm mt-0.5">Rabbit Platform Documentation</p>
          </div>
        </div>
        <p className="text-lg text-slate-600 max-w-2xl leading-relaxed">
          Everything you need to understand, configure, and build with Rabbit — the multi-tenant automation platform.
          Browse by topic below or use <kbd className="font-sans text-sm bg-slate-100 border border-slate-200 px-1.5 py-0.5 rounded">Ctrl K</kbd> to search.
        </p>
      </div>

      {/* Section cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {nav.map(section => (
          <div key={section.title} className="border border-slate-200 rounded-xl p-5 hover:border-blue-200 hover:shadow-sm transition-all">
            <div className="flex items-center gap-2 mb-3">
              <span className="text-xl">{section.icon}</span>
              <h2 className="font-semibold text-slate-800 text-[15px]">{section.title}</h2>
            </div>
            <ul className="space-y-1">
              {section.items.map(item => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="flex items-center gap-1.5 text-sm text-slate-600 hover:text-blue-600 py-0.5 group transition-colors"
                  >
                    <ArrowRight size={12} className="text-slate-300 group-hover:text-blue-400 shrink-0 transition-colors" />
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Footer note */}
      <div className="mt-12 text-center text-sm text-slate-400">
        <p>Can't find what you're looking for? Open an issue or ask on the team channel.</p>
      </div>
    </div>
  )
}
